/* global navigator: false, localStorage: false, window: false */

import en from './i18n/en.js';
import de from './i18n/de.js';
import featureFlags from "theme/utils/featureFlags.js";
import moment from 'moment';

let underscoreStringUpper = (string) => {
  // AbcXyz -> ABC_XYZ
  return string.split(/(?=[A-Z])/).join("_").toUpperCase();
};

let splitString = (string) => {
  // AbcXyz -> Abc xyz
  return string.split(/(?=[A-Z])/).join(" ").replace(/\s[A-Z]/g, (x) => x.toLowerCase());
};

let views = [
  "FLAGS",
  "COUNTRIES",
  "COUNTRY"
];

let setFeatureFlags = (featureFlags) => {
  featureFlags.map( flag => {
    views.map( view => {
      if(flag == "CASEmanInterfaceConfiguration") {
        en[view]["C_A_S_EMAN_INTERFACE_CONFIGURATION"] =  "Caseman interface configuration";
        de[view]["C_A_S_EMAN_INTERFACE_CONFIGURATION"] =  "Caseman interface configuration";
      } else if (flag == "CASEmanIncomeImport") {
        en[view]["C_A_S_EMAN_INCOME_IMPORT"] =  "Caseman income import";
        de[view]["C_A_S_EMAN_INCOME_IMPORT"] =  "Caseman income import";
      } else if(flag == "InterruptsOnClientView") {
        en[view]["INTERRUPTS_ON_CLIENT_VIEW"] =  "Interrupts on Client view";
        de[view]["INTERRUPTS_ON_CLIENT_VIEW"] =  "Interrupts on Client view";
      } else if(flag == "View360") {
        en[view]["VIEW360"] = "360 view";
        de[view]["VIEW360"] = "360 view";
      } else {
        en[view][underscoreStringUpper(flag)] = splitString(flag);
        de[view][underscoreStringUpper(flag)] = splitString(flag);
      }
    });
  });
};

setFeatureFlags(featureFlags);

export function i18nConfig ($translateProvider) {
  'ngInject';

  $translateProvider.translations('en_US', en);
  $translateProvider.translations('de_DE', de);

  $translateProvider.translations('en', en);
  $translateProvider.translations('de', de);

  let browserLang = null;

  if (navigator.language) {
    browserLang = navigator.language.replace('-', '_');
  } else {
    // for ie 10
    browserLang = navigator.browserLanguage.replace('-', '_');
  }

  if (browserLang.length < 3) {
    browserLang = browserLang + "_" + browserLang.toUpperCase();
  } else {
    var substrings = browserLang.split("_");
    browserLang = substrings[0] + "_" + substrings[1].toUpperCase();
  }

  if (!["en_US", "de_DE"].some((x) => x == browserLang)) {
    browserLang = "en_US";
  }

  let prefferedLanguage = localStorage.getItem("roedl-language") || (browserLang.length > 1 && browserLang) || "de_DE";

  localStorage.setItem("roedl-language", prefferedLanguage);
  window.dispatchEvent(new Event("storage"));
  $translateProvider.preferredLanguage(prefferedLanguage);
  $translateProvider.useSanitizeValueStrategy(null);
  moment.locale(prefferedLanguage);
}
